import { useAppSelector } from 'hooks/hooks'
import useMessagingCenter from 'hooks/useMessagingCenter'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { getAccessToken } from 'reducers/authSlice'
import styled from 'styled-components'
import { Category, HelpText, MessageType } from 'types/MessagingCenter'
import MessagingInboxScreen from './Inbox'

export default function MessagingCenter() {
  const location = useLocation()

  const route = location.pathname

  const [toggled, setToggled] = useState(false)
  const [showMenu, setShowMenu] = useState(true)
  const [showMobileMenu, setShowMobileMenu] = useState(false)
  const [isMobile, setIsMobile] = useState<boolean>(false)

  const [messageCategories, setMessageCategories] = useState<Category[]>([])
  const [newMessageBool, setNewMessageBool] = useState<boolean>(false)
  const [currentCategory, setCurrentCategory] = useState<Category | undefined>()
  const [currentTypes, setCurrentTypes] = useState<MessageType[]>([])
  const [currentHelpText, setCurrentHelpText] = useState<HelpText[]>([])
  const [currentType, setCurrentType] = useState<MessageType>()
  const [typeValue, setTypeValue] = useState<number>(0)
  const [categoryValue, setCategoryValue] = useState<number | undefined>()
  const [replyToTriaMessageId, setReplyToTriaMessageId] = useState<number>()

  const accessToken = useAppSelector(getAccessToken)
  const { getPatientMessagingCategories } = useMessagingCenter(accessToken!)

  useEffect(() => {
    //dispatch(setLoading(true))
    getPatientMessagingCategories().then((res) => {
      setMessageCategories(res.data.categories)
    })
  }, [])

  const setMobileSetting = () => {
    if (window.innerWidth < 900) {
      setIsMobile(true)
      setShowMobileMenu(true)
      setShowMenu(false)
    } else {
      setIsMobile(false)
      setShowMobileMenu(false)
      setShowMenu(true)
    }
  }
  useEffect(() => {
    setMobileSetting()
    window.addEventListener('resize', () => {
      setMobileSetting()
    })
  }, [])

  return (
    <div className="profile-page-container">
      <div className="profile-content-container">
        <StyledCareplanContainer>
          {(route === '/messaging/inbox' || route === '/messaging' || route === '/messaging/archive') && (
            <MessagingInboxScreen
              isMobile={isMobile}
              sideMenuToggled={() => setToggled(true)}
              messageCategories={messageCategories}
              setMessageCategories={(cat) => setMessageCategories(cat)}
              newMessageBool={newMessageBool}
              setNewMessageBool={(boolean) => setNewMessageBool(boolean)}
              currentCategory={currentCategory}
              setCurrentCategory={(cat) => setCurrentCategory(cat)}
              currentTypes={currentTypes}
              setCurrentTypes={(types) => setCurrentTypes(types)}
              currentHelpText={currentHelpText}
              setCurrentHelpText={(helpText) => setCurrentHelpText(helpText)}
              setCurrentType={(type) => setCurrentType(type)}
              currentType={currentType}
              typeValue={typeValue}
              setTypeValue={(typeValue) => setTypeValue(typeValue)}
              categoryValue={categoryValue}
              setCategoryValue={(categoryValue) => setCategoryValue(categoryValue)}
              replyToTriaMessageId={replyToTriaMessageId}
              setReplyToTriaMessageId={(number: number | undefined) => setReplyToTriaMessageId(number)}
            />
          )}
        </StyledCareplanContainer>
      </div>
    </div>
  )
}

const StyledCareplanContainer = styled.div`
  background-color: $neutral-color-1;
  color: $neutral-color-1;
  width: 100%;
  border-radius: 4px;
  padding-left: 2%;
  padding-right: 2%;
`
